import ApiService from '../../../../services/ApiService'

export default {
  name: 'ReferralAdmin',

  data: () => ({
    loading: false,
    statusLoading: false,
    showFilters: false,
    statusDialog: false,
    emailDialog: false,
    savingEmail: false,
    notificationEmail: '',
    apiService: new ApiService(),
    user: {},
    rows: [],
    editingRow: { status: null },
    sizes: [10, 25, 50, 100],
    filter: {
      institutionId: null,
      referredName: null,
      status: null,
      page: 1,
      pageSize: 10,
      totalItems: 0,
      totalPages: 0,
    },
    institution: {},
    headers: [
      { text: '', value: '', sortable: false },
      { text: 'Quem indicou', value: 'creatorName', align: 'center' },
      { text: 'E-mail (indicador)', value: 'creatorEmail', align: 'center' },
      { text: 'Empresa (indicador)', value: 'creatorCompany', align: 'center' },
      { text: 'Indicado', value: 'referredName', align: 'center' },
      { text: 'Empresa (indicado)', value: 'referredCompany', align: 'center' },
      { text: 'E-mail (indicado)', value: 'referredEmail', align: 'center' },
      { text: 'Telefone', value: 'referredPhone', align: 'center' },
      { text: 'Status', value: 'status', sortable: false, align: 'center' },
      { text: 'Data', value: 'createdAt', align: 'center' },
      { text: 'Ações', value: 'actions', sortable: false, align: 'center' },
    ],
    statusOptions: [
      { value: 0, label: 'Indicado', color: '#9E9E9E' },
      { value: 1, label: 'Em Negociação', color: '#FF9800' },
      { value: 2, label: 'Contratado', color: '#4CAF50' },
      { value: 3, label: 'Não Contratado', color: '#F44336' },
      { value: 4, label: 'Pago', color: '#2196F3' },
    ],
  }),

  created() {
    this.user = JSON.parse(localStorage.getItem('user'))
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.filter.institutionId = this.institution.id
    this.loadReferrals()
    if (this.user.mainType === 0 || this.user.mainType === 1) {
      this.loadNotificationEmail()
    }
  },

  methods: {
    async loadReferrals() {
      this.loading = true

      await this.apiService
        .post('ReferralLink/list', this.filter)
        .then((response) => {
          this.rows = response.content.referrals || []
          const pager = response.content.pager
          this.filter.page = pager.currentPage
          this.filter.pageSize = pager.pageSize
          this.filter.totalItems = pager.totalItems
          this.filter.totalPages = pager.totalPages
        })
        .catch(() => {
          this.$toast.error('Erro ao carregar indicações.')
        })
        .finally(() => {
          this.loading = false
        })
    },

    openStatusDialog(row) {
      this.editingRow = { ...row }
      this.statusDialog = true
    },

    async confirmStatus() {
      this.statusLoading = true

      await this.apiService
        .patch(`ReferralLink/referral/${this.editingRow.id}/status`, { status: this.editingRow.status })
        .then(() => {
          const target = this.rows.find((r) => r.id === this.editingRow.id)
          if (target) target.status = this.editingRow.status
          this.$toast.success('Status atualizado com sucesso!')
          this.statusDialog = false
        })
        .catch((err) => {
          this.$toast.error(err?.body?.message || 'Erro ao atualizar status.')
        })
        .finally(() => {
          this.statusLoading = false
        })
    },

    applyFilter() {
      this.filter.page = 1
      this.loadReferrals()
    },

    resetFilter() {
      this.filter.referredName = null
      this.filter.status = null
      this.filter.page = 1
      this.loadReferrals()
    },

    statusLabel(value) {
      return this.statusOptions.find((s) => s.value === value)?.label || '—'
    },

    statusColor(value) {
      return this.statusOptions.find((s) => s.value === value)?.color || '#9E9E9E'
    },

    async loadNotificationEmail() {
      await this.apiService
        .get('SystemSetting/referral-notification-email')
        .then((response) => {
          this.notificationEmail = response.content?.value || ''
        })
        .catch(() => {})
    },

    async saveNotificationEmail() {
      this.savingEmail = true
      await this.apiService
        .put('SystemSetting/referral-notification-email', { value: this.notificationEmail })
        .then(() => {
          this.$toast.success('E-mail de notificação salvo com sucesso!')
          this.emailDialog = false
        })
        .catch((err) => {
          this.$toast.error(err?.body?.message || 'Erro ao salvar e-mail.')
        })
        .finally(() => {
          this.savingEmail = false
        })
    },

    formatDate(date) {
      if (!date) return '—'
      return new Date(date).toLocaleDateString('pt-BR')
    },
  },

  watch: {
    'filter.page'() {
      this.loadReferrals()
    },
    'filter.pageSize'() {
      this.filter.page = 1
      this.loadReferrals()
    },
  },
}
